{
  "version": 1,
  "asset_id": "ef7df25b-8028-4708-a9de-ca51b96789b7",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/ef7df25b-8028-4708-a9de-ca51b96789b7/sylwia-rozmowa-1na1.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/ef7df25b-8028-4708-a9de-ca51b96789b7/sylwia-rozmowa-1na1.jpg",
  "original_filename": "sylwia-rozmowa-1na1.jpg",
  "size": 193964,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T07:44:46Z"
}
